import {
  PAYMENT_LINKS_ALLOWED_CURRENCIES_BY_COUNTRY,
  PAYMENT_LINKS_DEFAULT_CURRENCIES,
} from '@/shared/inswitch/constants/paymentLinksCurrencies.constant';

/**
 * Resuelve las monedas habilitadas para Links de Cobro según el país de origen de la empresa.
 * Falla cerrado: un país no mapeado —vacío, desconocido o indefinido— no habilita ninguna moneda,
 * en lugar de caer a una moneda por defecto.
 * El orden del array del mapa es además el orden de presentación en el selector de billeteras.
 * @param originCountryAlpha2 - Código alpha-2 del país de origen de la empresa.
 * @returns Lista de códigos de moneda habilitados, o lista vacía si el país no está mapeado.
 */
export function resolveAllowedPaymentLinksCurrencies(
  originCountryAlpha2: string | null | undefined
): readonly string[] {
  const normalizedCountry = (originCountryAlpha2 ?? '').trim().toUpperCase();
  return PAYMENT_LINKS_ALLOWED_CURRENCIES_BY_COUNTRY[normalizedCountry] ?? PAYMENT_LINKS_DEFAULT_CURRENCIES;
}
